import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../common/Spinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  passwordEnvVar: string;
  fallbackPassword: string;
  routeName: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  passwordEnvVar,
  fallbackPassword,
  routeName,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated in this session
    const isAlreadyAuthenticated =
      sessionStorage.getItem(`auth_${routeName}`) === "true";

    if (isAlreadyAuthenticated) {
      setIsAuthenticated(true);
      return;
    }

    // Prompt for password
    const password = prompt(`Enter ${routeName} password:`);

    if (password === null) {
      // User cancelled - redirect to home
      navigate("/");
      return;
    }

    const envPassword = process.env[passwordEnvVar];
    const isValidPassword =
      password === envPassword || password === fallbackPassword;

    if (isValidPassword) {
      // Store authentication in session storage
      sessionStorage.setItem(`auth_${routeName}`, "true");
      setIsAuthenticated(true);
    } else {
      alert("Incorrect password");
      navigate("/");
    }
  }, [passwordEnvVar, fallbackPassword, routeName, navigate]);

  if (isAuthenticated === null) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <Spinner size="lg" />
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : null;
};

export default ProtectedRoute;
